import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import PageHero from "../components/PageHero";
import { api, API, formatError } from "../lib/api";
import { Download, Loader2, ShieldCheck } from "lucide-react";

const fmtSize = (b) => `${(b / 1024 / 1024).toFixed(0)} MB`;

export default function AdminDataExport() {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/data-export/status").then((r) => setInfo(r.data)).catch((e) => setError(formatError(e)));
  }, []);

  const download = async () => {
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/admin/data-export/link");
      window.location.href = `${API}/admin/data-export/download/${encodeURIComponent(data.token)}`;
    } catch (e) { setError(formatError(e)); }
    setBusy(false);
  };

  return (
    <AppShell>
      <PageHero eyebrow="Admin" icon={ShieldCheck}
        title={<>Data <span className="text-grad">Export</span></>}
        subtitle="Download the full Preview data export. Each link works once, expires after 1 hour, and only for your admin session."
        testid="data-export-hero" />
      {error && <p className="text-sm text-destructive mb-4" data-testid="data-export-error">{error}</p>}
      {!info && !error && <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" data-testid="data-export-loading" />}
      {info && (
        <div className="rounded-2xl border border-border bg-white p-6 max-w-xl" data-testid="data-export-card">
          <p className="font-semibold text-foreground break-all" data-testid="data-export-filename">{info.filename}</p>
          <p className="text-sm text-muted-foreground mt-1" data-testid="data-export-size">
            {fmtSize(info.size_bytes)} · created {new Date(info.created_at).toLocaleString()}
          </p>
          <p className="text-xs text-muted-foreground mt-3">Contains sensitive customer data. Store it somewhere secure.</p>
          <button type="button" onClick={download} disabled={busy}
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm font-semibold hover:opacity-90 disabled:opacity-60"
            data-testid="data-export-download-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
            Download export
          </button>
        </div>
      )}
    </AppShell>
  );
}
